module.exports = __webpack_public_path__ + "img/wenliganzhiLeft.9ee4859b.gif";